var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#34495E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#203549"
    },
    d: "M411.43,216.358l-79.91-79.872l-39.567,39.572l7.862,7.823l-3.218,3.22l2.227,2.23l-10.639,10.644 l-18.068,6.18c-2.158,0.732-4.316,1.718-6.326,2.995c-0.077,0.041-0.113,0.077-0.182,0.113c-2.084,1.316-3.955,2.816-5.632,4.46 l-0.131,0.131l-37.793-37.796l-39.57-39.572l-0.003,0.005l-0.018-0.02l-79.887,79.887l39.57,39.572l37.842,37.839l-1.746,1.728 c-2.378,2.383-3.878,5.676-3.878,9.329c0,3.661,1.5,6.953,3.878,9.329L354.447,492.36c76.119-31.736,133.583-99.174,151.578-181.402 L411.43,216.358z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M288.189,199.99l-18.063,6.18c-2.24,0.765-4.419,1.784-6.51,3.09 c-2.097,1.311-3.968,2.816-5.632,4.488l-42.202,42.194l76.18,76.16l42.186-42.194c1.672-1.672,3.174-3.548,4.477-5.64 s2.33-4.27,3.09-6.502l6.177-18.079L288.189,199.99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEE2F2"
    },
    points: "358.543,249.06 347.894,259.686 288.189,199.99 298.831,189.348  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.77,314.153c-2.388,2.381-5.691,3.863-9.331,3.863c-3.653,0-6.948-1.482-9.331-3.863 l-39.56-39.547l18.662-18.665l39.557,39.549c2.386,2.391,3.863,5.699,3.863,9.329C339.633,308.47,338.155,311.764,335.77,314.153 L335.77,314.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.593,333.309c-2.378,2.396-5.678,3.878-9.321,3.878c-3.653,0-6.953-1.482-9.339-3.878 l-39.547-39.539l18.66-18.66l39.547,39.555c2.396,2.381,3.868,5.688,3.868,9.326C320.461,327.634,318.986,330.936,316.593,333.309 L316.593,333.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M297.428,352.497c-2.396,2.368-5.699,3.858-9.336,3.858c-3.643,0-6.935-1.49-9.326-3.858 l-39.555-39.567l18.655-18.647l39.562,39.547c2.388,2.401,3.855,5.683,3.855,9.329 C301.281,346.811,299.814,350.103,297.428,352.497L297.428,352.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.252,371.666c-2.383,2.396-5.688,3.863-9.326,3.863c-3.645,0-6.948-1.467-9.326-3.863 l-39.565-39.562l18.66-18.652l39.555,39.56c2.391,2.391,3.863,5.691,3.863,9.329C282.115,365.983,280.643,369.277,278.252,371.666 L278.252,371.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M164.091,259.686l6.182,18.079c0.76,2.232,1.797,4.411,3.095,6.502 c1.3,2.092,2.811,3.968,4.475,5.64l42.196,42.194l76.173-76.16l-42.196-42.194c-1.664-1.672-3.546-3.177-5.64-4.488 c-2.094-1.306-4.273-2.324-6.505-3.09l-18.079-6.18L164.091,259.686z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "213.166,189.348 223.795,199.99 164.091,259.686 153.444,249.052  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEE2F2"
    },
    points: "147.671,247.764 211.86,183.575 215.411,187.116 151.212,251.292 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.825,
    y: 168.229,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -91.7872 170.836)",
    style: {
      fill: "#0684BA"
    },
    width: 112.997,
    height: 55.971
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M135.465,235.553c-2.58-2.591-2.573-6.751,0.013-9.334c2.586-2.586,6.751-2.591,9.324,0 c2.591,2.583,2.609,6.743,0.018,9.334C142.228,238.136,138.063,238.136,135.465,235.553z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M233.738,371.666c-2.378-2.388-3.855-5.683-3.855-9.329c0-3.638,1.48-6.938,3.855-9.329l3.704-3.692 c2.378-2.396,5.683-3.878,9.321-3.878c3.645,0,6.945,1.482,9.341,3.878l0,0c2.378,2.373,3.855,5.676,3.855,9.321 c0,3.638-1.477,6.945-3.855,9.326l-3.709,3.702c-2.373,2.396-5.673,3.863-9.318,3.863 C239.421,375.526,236.122,374.06,233.738,371.666L233.738,371.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M214.572,352.497c-2.386-2.396-3.863-5.688-3.863-9.339c0-3.645,1.48-6.925,3.863-9.329l3.697-3.699 c2.383-2.376,5.688-3.858,9.331-3.858s6.935,1.482,9.324,3.858l0,0c2.391,2.396,3.868,5.696,3.868,9.334 c0,3.653-1.477,6.953-3.868,9.329l-3.702,3.707c-2.381,2.368-5.683,3.858-9.313,3.858 C220.25,356.355,216.955,354.865,214.572,352.497L214.572,352.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M195.397,333.309c-2.383-2.373-3.866-5.676-3.866-9.321c0-3.638,1.482-6.945,3.866-9.326 l3.697-3.702c2.396-2.388,5.688-3.863,9.331-3.863s6.935,1.475,9.331,3.863l0,0c2.383,2.396,3.855,5.699,3.855,9.341 c0,3.643-1.472,6.93-3.855,9.318l-3.699,3.686c-2.383,2.396-5.688,3.878-9.331,3.878 C201.075,337.188,197.783,335.706,195.397,333.309L195.397,333.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M176.22,314.153c-2.373-2.388-3.855-5.683-3.855-9.334c0-3.63,1.482-6.938,3.855-9.329l3.707-3.692 c2.381-2.396,5.683-3.871,9.324-3.871c3.64,0,6.943,1.475,9.336,3.871l0,0c2.373,2.388,3.855,5.681,3.855,9.326 c0,3.645-1.482,6.956-3.855,9.334l-3.709,3.694c-2.381,2.381-5.678,3.863-9.321,3.863 C181.911,318.016,178.609,316.534,176.22,314.153L176.22,314.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEE2F2"
    },
    d: "M281.825,227.197l-39.544,39.572c-2.388,2.381-5.693,3.863-9.334,3.863 c-0.95,0-1.871-0.108-2.767-0.302c-2.534-0.543-4.797-1.792-6.554-3.561c-1.777-1.769-3.041-4.04-3.581-6.561 c-0.189-0.896-0.292-1.82-0.292-2.783c0-3.64,1.48-6.935,3.873-9.321l34.358-34.358c1.664-1.679,3.535-3.177,5.632-4.48 c0.061-0.044,0.108-0.064,0.164-0.108L281.825,227.197z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "364.329,247.764 300.137,183.575 296.589,187.116 360.783,251.292 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.19,
    y: 168.226,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 461.6277 583.6328)",
    style: {
      fill: "#0684BA"
    },
    width: 112.997,
    height: 55.969
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M376.535,235.553c2.575-2.591,2.565-6.751-0.018-9.334c-2.586-2.586-6.746-2.591-9.336,0 c-2.591,2.583-2.591,6.743-0.005,9.334C369.772,238.136,373.932,238.136,376.535,235.553z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meetingIcon.f5afe13c58149ef6c5b406af668940d8.svg";
export { ForwardRef as ReactComponent };